// Project Page for Portfolio
// Project Section ->
//  Project 1
//  Project 2
//  Project 3
//  Project 4
//  Project 5

import React from 'react';

 const ProjectsPage = () => {
    return (
        <div>
            Projects Page
        </div>
    )
}

export default ProjectsPage